/* LOVEQUEEN - Instagram フィード
 * - graph.instagram.com から自分の投稿を取得してグリッドに表示（トークンはセクション設定）
 * - タップで拡大表示、前後の投稿へ（矢印 / ▲▼ / スワイプ / キーボード）
 * - トークンが無い・取得に失敗したときは、セクションの「手動の投稿」ブロックをそのまま使う
 */
(function () {
  'use strict';

  var API_BASE = 'https://graph.instagram.com/v26.0'; /* Instagram API with Instagram Login（Basic Display API は2024-12に終了） */
  var FIELDS = 'id,caption,media_type,media_url,thumbnail_url,permalink,timestamp,username,children{id,media_type,media_url,thumbnail_url}';
  var CACHE_MINUTES = 60; /* 訪問者ごとにAPIを叩かないよう、取得結果をブラウザに1時間保存（media_url の署名は数日で切れるので長くしない） */

  function pickImage(item) {
    if (!item) return '';
    if (item.media_type === 'IMAGE') return item.media_url || '';
    if (item.media_type === 'VIDEO') return item.thumbnail_url || '';
    if (item.media_type === 'CAROUSEL_ALBUM') {
      var kids = item.children && item.children.data ? item.children.data : [];
      for (var i = 0; i < kids.length; i++) {
        var u = pickImage(kids[i]);
        if (u) return u;
      }
      return item.media_url || item.thumbnail_url || '';
    }
    return item.media_url || item.thumbnail_url || '';
  }

  function formatDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    var now = new Date();
    var md = (d.getMonth() + 1) + '月' + d.getDate() + '日';
    return d.getFullYear() === now.getFullYear() ? md : d.getFullYear() + '年' + md;
  }

  function cacheKey(token, limit) { return 'lqig:' + limit + ':' + token.slice(-12); }

  function store() { try { return window.localStorage; } catch (e) { try { return window.sessionStorage; } catch (e2) { return null; } } }
  function readCache(key) {
    try {
      var st = store(); if (!st) return null;
      var raw = st.getItem(key);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || !obj.t || !obj.posts || !obj.posts.length) return null;
      if ((Date.now() - obj.t) > CACHE_MINUTES * 60 * 1000) return null;
      return obj.posts;
    } catch (e) { return null; }
  }
  function writeCache(key, posts) {
    try { var st = store(); if (st) st.setItem(key, JSON.stringify({ t: Date.now(), posts: posts })); } catch (e) {}
  }

  function fetchPosts(token, limit) {
    var url = API_BASE + '/me/media?fields=' + encodeURIComponent(FIELDS) + '&limit=' + encodeURIComponent(limit) + '&access_token=' + encodeURIComponent(token);
    /* 単純なGET（トークンはクエリ、独自ヘッダー無し）: graph.instagram.com は CORS で access-control-allow-origin: * を返す */
    return fetch(url, { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (json) {
      if (!json || !json.data) {
        var msg = json && json.error && json.error.message ? json.error.message : 'unknown';
        var code = json && json.error && json.error.code ? json.error.code : 0;
        var err = new Error('Instagram API: ' + msg);
        err.igCode = code; /* 190 = トークン無効・期限切れ */
        throw err;
      }
      var posts = [];
      for (var i = 0; i < json.data.length; i++) {
        var it = json.data[i];
        var img = pickImage(it);
        if (!img) continue;
        posts.push({
          id: it.id,
          img: img,
          caption: it.caption || '',
          link: it.permalink || '',
          date: formatDate(it.timestamp),
          username: it.username || ''
        });
      }
      return posts;
    });
  }

  function manualPosts(root) {
    var items = root.querySelectorAll('[data-lqig-item]');
    var posts = [];
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      posts.push({
        id: 'manual-' + i,
        img: el.getAttribute('data-img') || (el.querySelector('img') ? el.querySelector('img').src : ''),
        caption: el.getAttribute('data-caption') || '',
        link: el.getAttribute('data-link') || '',
        date: el.getAttribute('data-date') || '',
        username: ''
      });
    }
    return posts;
  }

  function renderGrid(grid, posts) {
    var html = '';
    for (var i = 0; i < posts.length; i++) {
      var p = posts[i];
      html += '<button type="button" class="lqig__item" data-lqig-item data-index="' + i + '" aria-label="投稿を開く">' +
        '<img src="' + p.img.replace(/"/g, '&quot;') + '" alt="" loading="lazy" referrerpolicy="no-referrer">' +
        '</button>';
    }
    grid.innerHTML = html;
  }

  function init(root) {
    if (!root || root.dataset.lqigInit) return;
    root.dataset.lqigInit = '1';

    var token = (root.getAttribute('data-token') || '').trim();
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 9;
    var username = root.getAttribute('data-username') || '';
    var profile = root.getAttribute('data-profile') || '';
    var grid = root.querySelector('[data-lqig-grid]');
    var modal = root.querySelector('[data-lqig-modal]');
    if (!grid || !modal) return;

    /* 拡大表示は body 直下へ（親の効果に閉じ込められないように）。同じIDの古いものが残っていれば先に消す */
    var stale = document.getElementById(modal.id);
    if (stale && stale !== modal && stale.parentElement === document.body) stale.parentElement.removeChild(stale);
    document.body.appendChild(modal);
    root.lqigModal = modal;

    var photo = modal.querySelector('[data-lqig-photo]');
    var captionEl = modal.querySelector('[data-lqig-caption]');
    var dateEl = modal.querySelector('[data-lqig-date]');
    var unameEl = modal.querySelector('[data-lqig-uname]');
    var accountEl = modal.querySelector('[data-lqig-account]');
    var permalinkEl = modal.querySelector('[data-lqig-permalink]');
    var media = modal.querySelector('[data-lqig-media]');

    var posts = [];
    var cur = 0, open = false, seq = 0, lastFocus = null, scrollY = 0;

    function show(i) {
      if (!posts.length) return;
      cur = (i + posts.length) % posts.length;
      var p = posts[cur];
      var mySeq = ++seq; /* 古い先読みの完了で写真が戻らないように */
      photo.classList.add('is-loading');
      var pre = new Image();
      var done = false;
      function reveal() { if (done || mySeq !== seq) return; done = true; photo.src = p.img; photo.classList.remove('is-loading'); }
      pre.onload = reveal; pre.onerror = reveal; pre.src = p.img;
      if (pre.complete) reveal();
      setTimeout(reveal, 1500);
      captionEl.textContent = p.caption || '';
      dateEl.textContent = p.date || '';
      if (unameEl) unameEl.textContent = p.username || username || '';
      if (accountEl) {
        var acc = profile || (p.username ? 'https://www.instagram.com/' + p.username + '/' : '');
        if (acc) { accountEl.setAttribute('href', acc); } else { accountEl.removeAttribute('href'); }
      }
      if (permalinkEl) {
        if (p.link) { permalinkEl.href = p.link; permalinkEl.hidden = false; } else { permalinkEl.hidden = true; }
      }
      /* 次と前を先読み */
      if (posts.length > 1) { new Image().src = posts[(cur + 1) % posts.length].img; new Image().src = posts[(cur - 1 + posts.length) % posts.length].img; }
      var body = modal.querySelector('.lqig__body'); if (body) body.scrollTop = 0;
      var card = modal.querySelector('[data-lqig-card]'); if (card) card.scrollTop = 0;
    }
    function lockScroll() {
      scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.body.classList.add('lqig-lock');
      document.body.style.top = (-scrollY) + 'px'; /* iOS Safari でも背面が動かないように */
    }
    function unlockScroll() {
      document.body.classList.remove('lqig-lock');
      document.body.style.top = '';
      window.scrollTo(0, scrollY);
    }
    function openAt(i) {
      open = true; lastFocus = document.activeElement;
      modal.hidden = false; lockScroll(); show(i);
      var c = modal.querySelector('[data-lqig-close]'); if (c && c.focus) c.focus();
    }
    function close() {
      if (!open) return;
      open = false; modal.hidden = true; unlockScroll();
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    }
    function go(d) { show(cur + d); }

    grid.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-lqig-item]') : null;
      if (!btn) return;
      e.preventDefault();
      var i = parseInt(btn.getAttribute('data-index'), 10);
      if (isNaN(i)) { /* 手動ブロック（初期描画）: 位置から求める */
        var all = grid.querySelectorAll('[data-lqig-item]'); i = Array.prototype.indexOf.call(all, btn);
      }
      openAt(i < 0 ? 0 : i);
    });

    modal.querySelectorAll('[data-lqig-close]').forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); close(); }); });
    modal.querySelectorAll('[data-lqig-prev]').forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); go(-1); }); });
    modal.querySelectorAll('[data-lqig-next]').forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); go(1); }); });
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    root.lqigKey = function (e) {
      if (!open) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') go(1);
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') go(-1);
    };
    document.addEventListener('keydown', root.lqigKey);
    root.lqigClose = close;

    /* スワイプ（写真の上で横・縦どちらでも） */
    var sx = null, sy = null, st = 0;
    media.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { sx = null; return; }
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; st = Date.now();
    }, { passive: true });
    media.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var t = e.changedTouches[0]; var dx = t.clientX - sx, dy = t.clientY - sy; sx = null;
      if (Date.now() - st > 800) return;
      if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
      else if (Math.abs(dy) >= 40 && Math.abs(dy) > Math.abs(dx)) go(dy < 0 ? 1 : -1);
    }, { passive: true });

    /* 投稿の読み込み */
    var isEditor = root.getAttribute('data-editor') === '1';
    var statusEl = root.querySelector('[data-lqig-status]');
    function setStatus(text, cls) {
      if (!isEditor) return;
      if (!statusEl) { statusEl = document.createElement('div'); statusEl.className = 'lqig__hint'; root.appendChild(statusEl); }
      statusEl.className = 'lqig__hint' + (cls ? ' ' + cls : '');
      statusEl.textContent = text;
    }
    posts = manualPosts(root);
    if (token) {
      var key = cacheKey(token, limit);
      var cached = readCache(key);
      function useApi(list, fromCache) {
        if (!list || !list.length) return;
        posts = list;
        renderGrid(grid, posts);
        root.hidden = false; /* お客様向け: 投稿が取れたときだけ表示 */
        setStatus('Instagram 連携: 正常（' + list.length + '件を表示' + (fromCache ? '・キャッシュ' : '') + '）', 'is-ok');
      }
      if (cached) useApi(cached, true);
      fetchPosts(token, limit).then(function (list) {
        if (list.length) writeCache(key, list);
        if (list.length) useApi(list, false);
        else setStatus('Instagram 連携: 接続はできましたが、表示できる投稿がありません（投稿がまだ無い、または写真の無い投稿のみ）', 'is-error');
      }).catch(function (err) {
        if (window.console) console.warn('[LOVEQUEEN Instagram] ' + err.message);
        var why = err.igCode === 190 ? 'アクセストークンが無効か期限切れです。Meta for Developers で新しいトークンを生成して貼り直してください。' : 'トークンの入力ミス・権限不足・通信エラーの可能性があります。';
        setStatus('⚠ Instagram の投稿を取得できませんでした: ' + err.message + '。' + why + (posts.length ? ' いまは「手動の投稿」を表示しています。' : ' お客様にはこのセクションは表示されていません。'), 'is-error');
      });
    }
  }

  function initAll() { document.querySelectorAll('[data-lqig]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector ? e.target.querySelector('[data-lqig]') : null;
    if (r) init(r);
  });
  /* テーマエディタでセクションが外れたら、body に移した拡大表示も片付ける */
  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target && e.target.querySelector ? e.target.querySelector('[data-lqig]') : null;
    if (!r) return;
    if (r.lqigClose) r.lqigClose();
    if (r.lqigKey) document.removeEventListener('keydown', r.lqigKey);
    var m = r.lqigModal;
    if (m && m.parentElement) m.parentElement.removeChild(m);
  });
})();
